import { Box, Typography, Divider, Button } from '@mui/material';
import { useLogic } from './logic';
import { MuiButton } from '@/components/button/MuiButton';
import { SearchFilterList } from './SearchFilterList';
import { api_portalOfficeListing_filter } from '@/init/swagger';
import LockIcon from '@mui/icons-material/Lock';

type Props = {
  search: () => void;
  searchFilters: api_portalOfficeListing_filter[];
};

export function PublicHomeSearchFilterBox({ search, searchFilters }: Props) {
  const { showMore, setShowMore, filters, toggleCheckbox, resetStationFilter } =
    useLogic({
      search,
      searchFilters,
    });

  return (
    <Box
      bgcolor="#F5FAFA"
      p={3}
      borderRadius={2}
      sx={{
        '@media (max-width: 999px)': {
          position: 'relative',
          height: showMore ? 'auto' : '300px',
          overflow: 'hidden',
          pb: 5,
          '&:before': {
            zIndex: 1,
            position: 'absolute',
            display: showMore ? 'none' : 'block',
            content: '""',
            bottom: 0,
            left: 0,
            width: '100%',
            height: '75px',
            background: `linear-gradient(rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.8) 40%, #fff 100%)`,
          },
        },
      }}
    >
      <Box className="filter-content">
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography variant="JP/Heading/s/Bold/Tight">
              看護・介護サービスを絞る
            </Typography>

            <MuiButton
              color="primary"
              variant="text"
              onClick={resetStationFilter}
            >
              クリア
            </MuiButton>
          </Box>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Typography variant="JP/Body/m/Medium/Tight" component="p">
              サービス
            </Typography>
            <SearchFilterList
              filters={filters.services}
              toggleCheckbox={toggleCheckbox}
            />
          </Box>

          <Divider />

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: 1,
              alignItems: 'center',
            }}
          >
            <LockIcon
              sx={{
                color: '#FFB300',
              }}
            />
            <Typography variant="JP/Body/m/Medium/Tight" component="p">
              5個の絞り込み項目
            </Typography>
          </Box>
        </Box>
      </Box>

      <Button
        component="label"
        variant="outlined"
        onClick={() => setShowMore(!showMore)}
        sx={{
          display: 'none',
          '@media (max-width: 999px)': {
            position: 'absolute',
            display: 'block',
            left: '50%',
            bottom: showMore ? '8px' : 0,
            margin: '0 auto',
            width: '200px',
            textAlign: 'center',
            transform: `translateX(-50%)`,
            zIndex: 2,
            '&:before': {
              content: showMore ? '"閉じる"' : '"開く"',
            },
          },
        }}
      />
    </Box>
  );
}
